<template>
  <div :class="classes">
  <pt-page-title title="生命体验馆预约财务审核" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
    </pt-page-title>
    <pt-page-menu-filter :tabs="tabs" v-model="selectTab" :showCountOfRightTop="true" isRouteQuery></pt-page-menu-filter>
    <pt-life-experience-pavilion-reservation-table ref="table" :params="paramsQuery" :isFinanceAudit="true" :isFromRouter="true"
    :class="$style['pt-invoice-table']" >
    </pt-life-experience-pavilion-reservation-table>
  </div>
</template>

<script>
import { statusTabs } from './pt-life-experience-finance-audit'
import ptLifeExperiencePavilionReservationTable from '../pt-life-experience-pavilion-reservation//pt-life-experience-pavilion-reservation-table/withData.vue'
// 组件class前缀
const prefixCls = 'pt-life-experience-finance-audit'

export default {
  name: 'pt-life-experience-finance-audit',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptLifeExperiencePavilionReservationTable
  },
  data  () {
    return {
      paramsQuery: {
        status: '1',
        page: 1,
        pageSize: 10,
        search: '',
        filter: ''
      },
      tabs: statusTabs,
      selectTab: 'WAITING_FINANCE_AUDIT',
      searchKey: null
    }
  },
  watch: {
    selectTab: {
      handler: function (val, old) {
        this.searchKey = null
        this.paramsQuery = { status: val }
      },
      immediate: true
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.paramsQuery = { ...this.paramsQuery, searchKey: val }
      console.log(this.paramsQuery)
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.paramsQuery, 'searchKey')
    }
  }

}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
